export type ParticipantRole =
  | 'vip'
  | 'speaker'
  | 'organiser'
  | 'media'
  | 'sponsor'
  | 'exhibitor'
  | 'student_innovator'
  | 'delegate'
  | 'visitor'
  | 'contractor';

export interface RoleTheme {
  role: ParticipantRole;
  label: string;
  shortCode: string;
  colorHex: string;
  badge: string;
  badgeClass: string;
  textClass: string;
  borderClass: string;
}

export const ROLE_THEMES: Record<ParticipantRole, RoleTheme> = {
  vip: {
    role: 'vip',
    label: 'VIP',
    shortCode: 'VIP',
    colorHex: '#C5A059',
    badge: 'bg-[#FAF5EA] text-[#785613] border border-[#E6C687]',
    badgeClass: 'bg-[#FAF5EA] text-[#785613]',
    textClass: 'text-[#785613]',
    borderClass: 'border-[#E6C687]',
  },
  speaker: {
    role: 'speaker',
    label: 'Speaker',
    shortCode: 'S',
    colorHex: '#B91C1C',
    badge: 'bg-rose-50 text-rose-800 border border-rose-200',
    badgeClass: 'bg-rose-50 text-rose-800',
    textClass: 'text-rose-800',
    borderClass: 'border-rose-200',
  },
  organiser: {
    role: 'organiser',
    label: 'Organiser',
    shortCode: 'O',
    colorHex: '#0F172A',
    badge: 'bg-slate-900 text-white border border-slate-800',
    badgeClass: 'bg-slate-900 text-white',
    textClass: 'text-slate-900',
    borderClass: 'border-slate-800',
  },
  media: {
    role: 'media',
    label: 'Media',
    shortCode: 'M',
    colorHex: '#EA580C',
    badge: 'bg-orange-50 text-orange-800 border border-orange-200',
    badgeClass: 'bg-orange-50 text-orange-800',
    textClass: 'text-orange-800',
    borderClass: 'border-orange-200',
  },
  sponsor: {
    role: 'sponsor',
    label: 'Sponsor',
    shortCode: 'SP',
    colorHex: '#4338CA',
    badge: 'bg-indigo-50 text-indigo-800 border border-indigo-200',
    badgeClass: 'bg-indigo-50 text-indigo-800',
    textClass: 'text-indigo-800',
    borderClass: 'border-indigo-200',
  },
  exhibitor: {
    role: 'exhibitor',
    label: 'Exhibitor',
    shortCode: 'E',
    colorHex: '#0284C7',
    badge: 'bg-sky-50 text-sky-800 border border-sky-200',
    badgeClass: 'bg-sky-50 text-sky-800',
    textClass: 'text-sky-800',
    borderClass: 'border-sky-200',
  },
  student_innovator: {
    role: 'student_innovator',
    label: 'Student Innovator',
    shortCode: 'SI',
    colorHex: '#65A30D',
    badge: 'bg-lime-50 text-lime-800 border border-lime-200',
    badgeClass: 'bg-lime-50 text-lime-800',
    textClass: 'text-lime-800',
    borderClass: 'border-lime-200',
  },
  delegate: {
    role: 'delegate',
    label: 'Delegate',
    shortCode: 'D',
    colorHex: '#047857',
    badge: 'bg-emerald-50 text-emerald-800 border border-emerald-200',
    badgeClass: 'bg-emerald-50 text-emerald-800',
    textClass: 'text-emerald-800',
    borderClass: 'border-emerald-200',
  },
  visitor: {
    role: 'visitor',
    label: 'Visitor',
    shortCode: 'V',
    colorHex: '#475569',
    badge: 'bg-slate-100 text-slate-800 border border-slate-200',
    badgeClass: 'bg-slate-100 text-slate-800',
    textClass: 'text-slate-800',
    borderClass: 'border-slate-200',
  },
  contractor: {
    role: 'contractor',
    label: 'Contractor',
    shortCode: 'C',
    colorHex: '#64748B',
    badge: 'bg-zinc-100 text-zinc-800 border border-zinc-200',
    badgeClass: 'bg-zinc-100 text-zinc-800',
    textClass: 'text-zinc-800',
    borderClass: 'border-zinc-200',
  },
};
